export const CANCELLED = 'CANCELLED';
export const CLAIM_EXIST = 'CLAIM_EXIST';
export const CASE_OPENED = 'CASE_OPENED';
